"use client"
import React from "react"
import Navbar from "../../components/admin/common/Navbar"
import CampaignCreate from "../../components/admin/marketing/CampaignCreate"

const MarketingCampaignCreate = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
        <CampaignCreate />
      </main>
    </div>
  )
}

export default MarketingCampaignCreate
